import api from '@/lib/api';
import type { NotificationListResponse, UnreadCountResponse } from './types';

export const notificationsApi = {
    list: (page = 1, pageSize = 20) =>
        api.get<NotificationListResponse>('/notifications', {
            params: { page, page_size: pageSize },
        }),

    unreadCount: () =>
        api.get<UnreadCountResponse>('/notifications/unread-count'),

    markRead: (id: string) =>
        api.patch(`/notifications/${id}/read`),

    markAllRead: () =>
        api.post('/notifications/read-all'),
};
